import React from 'react';
import { withTranslation } from "react-i18next";
import './../Reporting.scss';

const BRSRSectionC = ({
	t
}) => {
	return (
		<section id="Section_C" className="Main_Section Section_C">
			<div className="ETA_card_Section_wrapper">
				<div className="ETA_card_Section 1">
					<div className="ETA_card_Section_head">
						<h5>SECTION C: PRINCIPLE WISE PERFORMANCE DISCLOSURE   </h5>
					</div>
					<div className="ETA_card_Section_sub">
						<p>This section is aimed at helping entities demonstrate their performance in integrating the Principles and Core Elements with key processes and decisions. The information sought is categorized as "Essential" and "Leadership". While the essential indicators are expected to be disclosed by every entity that is mandated to file this report, the leadership indicators may be voluntarily disclosed by entities which aspire to progress to a higher level in their quest to be socially, environmentally and ethically responsible. </p>
					</div>
				</div>
			</div>
		</section>
	);
};

export default withTranslation()(BRSRSectionC);
